export { default } from './Search';
export type { Props, Props as SearchHeroBannerProps } from './Search';
